import send from './send';

const ApiCall = {
  send,
};

export default ApiCall;
